<template>
    <div class="card rounded-xl p-10px mb-4 last:mb-0" @click="onClickItem()">
        <div class="flex items-start">
            <div class="flex-none img flex justify-center">
                <div class="relative inline-block rounded">
                    <img :src="campaign.fullImageUrl" class="mx-auto rounded block" alt />
                    <div v-if="campaign.qty < 1" class="disabled-item flex items-center justify-center">
                        <div class="inline-block py-1 px-1.5 rounded-tl-20px rounded-br-20px label-bg">
                            <span class="text-white font-medium" :class="localeCode === 1033 ? 'text-xs' : 'text-base'">{{ lbl.default.soldOut }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-auto ml-10px">
                <template v-if="!!campaign.agencyName">
                    <div class="mb-2 text-primary-50 text-sm uppercase">{{ campaign.name_brand }}</div>
                </template>
                <div class="text-primary line-clamp-2 leading-5">{{ campaign.name }}</div>
                <div class="mt-2 text-gray-500 text-sm">{{ lbl.default.period }} : {{ dateComputed }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import DatetimeHelper from "@/helper/DatetimeHelper"
import LocaleMixin from "@/mixin/LocaleMixin"

export default {
    name: "PromotionItem",
    props: {
        campaign: {
            type: Object
        }
    },
    mixins: [LocaleMixin],
    computed: {
        dateComputed: function () {
            let start = null
            let expire = null

            if (this.campaign.startDate) {
                start = DatetimeHelper.unixTimestampToDate(this.campaign.startDate)
            }

            if (this.campaign.expireDate) {
                expire = DatetimeHelper.unixTimestampToDate(this.campaign.expireDate)
            }

            let outFormat = 'd MMM yy'

            if (start != null && expire != null) {
                return `${DatetimeHelper.dateFullFormat(start, outFormat)} - ${DatetimeHelper.dateFullFormat(expire, outFormat)}`
            } else if (start != null && expire == null) {
                return `${DatetimeHelper.dateFullFormat(start, outFormat)}`
            }
            else if (start == null && expire != null) {
                return `${DatetimeHelper.dateFullFormat(expire, outFormat)}`
            } else {
                return ''
            }

        }
    },
    emits: ["onClickItem"],
    methods: {
        onClickItem: function () {
            this.$emit("onClickItem", this.campaign)
        }
    }
}
</script>


<style lang="scss" scoped>
.card {
    box-shadow: 0 4px 4px 0 #e0efff;
    border: solid 1px #e3e8f3;
    background-color: #fff;
    min-height: 117px;

    .img {
        width: 110px;

        img {
            max-width: 110px;
            height: auto;
            max-height: 73px;
        }
    }
}
.disabled-item {
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background-color: rgba(0, 0, 0, 0.4);
}
.label-bg {
    background-color: rgba(0, 0, 0, 0.6);
}
</style>
